/**
 * Imperative DOM toast helper — promoted from the inline pattern in
 * pages/FrontDeskPage.tsx so every editor surface shares one. Success toasts are
 * `role="status" aria-live="polite"`; error toasts are `role="alert"
 * aria-live="assertive"`. Auto-dismiss after 3s.
 */
export type ToastVariant = 'success' | 'error';

export function showToast(message: string, variant: ToastVariant = 'success'): void {
  const el = document.createElement('div');
  const isError = variant === 'error';
  el.setAttribute('role', isError ? 'alert' : 'status');
  el.setAttribute('aria-live', isError ? 'assertive' : 'polite');
  el.className = [
    'fixed bottom-4 right-4 z-[100] px-4 py-3 rounded-lg shadow-lg text-sm font-medium animate-slide-in max-w-sm',
    isError ? 'bg-red-600 text-white' : 'bg-green-600 text-white',
  ].join(' ');
  el.textContent = message;
  document.body.appendChild(el);
  setTimeout(() => {
    el.style.opacity = '0';
    el.style.transition = 'opacity 300ms';
    setTimeout(() => el.remove(), 300);
  }, 3000);
}
